import { createAdvancedMarker } from './html-map-marker'
import ListUtil from '../pricetravel/list/utils';
import { getHeaders } from '../pricetravel/shared/tokenUtil';
import { AMENITIES_DESCRIPTIONS } from '../../utils/pricetravel/shared/cardService'
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { useHotelBookerStore } from '../../vue/stores/hotelBooker';
import pinia from '../../vue/stores/store';
export default class GoogleMapList {
    constructor(model, http, filter, scope, userKeyFac) {
        this.vm = model;
        this.http = http;
        this.exchange = window.__pt.exchange;
        this.filter = filter;
        this.scope = scope;
        this.fn = window.__pt.fn;
        this.config = window.__pt.settings.site;
        this.resolution = window.__pt.resolution;
        this.box = window.__pt.box;
        this._userKeyFac = userKeyFac;
        this.showServices = this.config.showServices;
        this.map = null;
        this.markers = [];
        this.markerMap = new Map();
        this.markerCluster = null;
        this.mapInitialized = false;
        this.lib = { maps: null, marker: null };
        this._lastFiltersKey = null;
        this._mapUpdateTimeout = null;
        this._isUpdatingMarkers = false;
        this.MAX_TOTAL_MARKERS = 1000;
        this.MAX_VISIBLE_LIMIT = 150;
        this._lastMarkerIds = "";
        this.currentSort = "savings";
        this.textOrderBy = this.vm.ln.savings;
        this.safeApply = fn => {
            if (!this.scope.$$phase && !this.scope.$root.$$phase) {
                this.scope.$apply(fn);
            } else {
                fn();
            }
        };
        this.hotelBookerStore = useHotelBookerStore(pinia);
        this.isNearbyFlow = new URLSearchParams(window.location.search).get('nearby');
        this.userCoords = null;
        this.vm.mapList = this;
        this.lastSelectionTime = 0;
        this.vm.onCloseMapCardDetail = (isOffClick = false) => {
            if (isOffClick && Date.now() - this.lastSelectionTime < 500) {
                return;
            }
            this.safeApply(() => {
                this.deselectHotel();
            });
        };
        
        this.vm.onImgError = (event) => this.onImgError(event);
    }
    
    onImgError(event) {
        let code = "us";
        if (this.config && this.config.siteName === "tiquetesbaratos") {
            code = "co";
        }
        event.target.src = `/assets/img/placeholder_img_${code}.png`;
        event.target.onerror = null;
    }
    deselectHotel() {
        this.vm.detailCardMap.show = false;
        this.vm.detailCardMap.id = null;
        this.clearBubble();
    }

    async getLocationUser() {
        try {
            if (!pinia) return false;

            const pos = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                });
            });

            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;

            const params = {
                Latitude: lat,
                Longitude: lng,
                radiusKm: 50,
                SiteSearch: this.config.code,
            };

            let headers = getHeaders();
            let response = await this.http.get(this.config.endPoints.nearbyDestinationUrl, { params, headers });
            
            if (response && response.data && response.data.length > 0) {
                let data = response.data;
                data.forEach((element) => {
                    const [city, ...locationParts] =
                        element.type == 11
                        ? element.displayHtml.split("-").map((part) => part.trim())
                        : element.displayHtml.split(",").map((part) => part.trim());
                    element.city =
                            element.type == 11
                            ? `${locationParts
                                .join(", ")
                                .replace(" " + element.code + " ", "")} (${element.code})`
                            : city;
                    element.location =
                        element.type === 11
                        ? city.replace(element.code + " ", "")
                        : locationParts.join(", ");
                });
                const locationItem = data[0];
                const hotelBookerStore = useHotelBookerStore(pinia);
                
                hotelBookerStore.setNearbyLocation({ 
                    ...locationItem,
                    coords: { lat, lng }
                });
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }
    initialize() {
        this.hotels = [];
        this.itemsHotel = null;
        this.isFilterView = false;
        this.vm.isMapExpanded = false;
        this.vm.toggleExpand = () => this.toggleExpand();
        this.vm.showMapDetail = false;
        this.vm.detailCardMap = {};
        this.vm.loading_refresh_map = null;
        this.vm.loading = true;
        this.vm.renderMapList = false; // Nueva bandera para la lista

        if (this.onRenderMap()) {
            this.getHotels();
        }
        this.clearMarkers();
    }
    openMap(params, paramsRates, paxes, campaignToken, paramsFilter, isNearby = false) {
        $(`#modal-mapsearch`).modal("show");
        this.params = params;
        this.paramsRates = paramsRates;
        this.paxes = paxes;
        this.campaignToken = campaignToken;
        this.paramsFilter = paramsFilter;
        this.initialize();
        $(`#modal-mapsearch`).off('shown.bs.modal').on('shown.bs.modal', () => {
            if (this.map) {
                google.maps.event.trigger(this.map, 'resize');
                
                this.userCoords = this.hotelBookerStore.nearbyLocation?.coords;

                if (this.isNearbyFlow && this.userCoords) {
                    this.map.setCenter({ lat: this.userCoords.lat, lng: this.userCoords.lng });
                    this.map.setZoom(13);
                } else if (this._lastBounds) {
                    this.map.fitBounds(this._lastBounds, 80);
                }
            }
        });
        this._listUtil = new ListUtil(params, this.config, "...");
    }
    async getHotels() {
        this.vm.getUSersFavorites();
        this.vm.loading = true;
        let paramsClone = this.fn.clone(this.paramsFilter);
        paramsClone.page = 1;
        paramsClone.profileId = this.vm.paramsFilter.profileId;
        paramsClone.pageSize = this.config.listItemsMapCount;
        paramsClone.filters = this.vm.filtersSelectedArrayString.join(",");
        paramsClone.filtersCustom = this.vm.filterCustomList.map(f => f.uri).join(",");
        paramsClone.bedMax = +this.vm.filtersComposition.beds;
        paramsClone.bathroomMax = +this.vm.filtersComposition.bathRooms;
        paramsClone.bedroomMax = +this.vm.filtersComposition.bedRooms;
        paramsClone.isPetFriendly = this.vm.filtersComposition.isPetFriendly;
        let headers = getHeaders();
        try {
            let response = await this.http.get(this.config.endPoints.filterUrl, { params: paramsClone, headers });
            if (response && response.data && response.data.accommodations) {
                this.hotels = response.data.accommodations;
                this.safeApply(() => { 
                this.vm.pagination.totalHotels = response.data.totalItems;
                this.vm.hotelFilters = response.data;
                this.vm.onLoadFilters(response.data.filterGroups);
                this.vm.hotelFilters.filterCustoms.filterGroups = this._listUtil.setIsSelectCustomFilter(response.data.filterCustoms.filterGroups);
                this.vm.composition = this.vm.hotelFilters.filterCustoms.composition;
                this.vm.popularFilters = this.vm.hotelFilters.filterCustoms.filterPopular || [];
                this.vm.hotelFilters.filterCustoms.prices.min = (response.data.filterCustoms.prices.min) * this.exchange.rate;
                this.vm.hotelFilters.filterCustoms.prices.max = (response.data.filterCustoms.prices.max) * this.exchange.rate;
                this.vm.updateFilterCustom();
                
                });
            } else {
                this.hotels = [];
                this.vm.pagination.totalHotels = 0;
            }
        } catch (error) {
            console.error("Error fetching map hotels:", error);
            this.hotels = [];
        }
        if (this.hotels.length > 0) {
            this.getRates();
        } else {
            this.clearMarkers();
            this.safeApply(() => {
                this.vm.no_result_map = 0;
                this.vm.loading = false;
                this.vm.loading_refresh_map = false;
            });
        }
    }
    async getRates() {
        this.safeApply(() => { this.vm.no_result_map = true; });
        this.vm.loading_refresh_map = true;
        this.createUrlDetail();
        await this.centerMap();
    }
    createUrlDetail() {
        let pax = this.fn.mapPaxToUrl(this.box.pax);
        let base = { checkin: this.box.checkIn, checkout: this.box.checkOut, ...pax };
        if (this.campaignToken) base.CampaignToken = this.campaignToken;
        let query = this.fn.objectToQueryParams(base);
        this.hotels.forEach(h => {
            h.url = `${this.config.siteUrl}${this.config.pathHotelDetail}${h.uri}?${query}`;
        });
    }
    onRenderMap() {
        if ('google' in window && google.maps) {
            return true;
        }
        this.fn.getScript(this.config.endPoints.googleMapsApi, "", () => {
            this.getHotels();
        });
        return false;
    }
    async centerMap() {
        this.itemsHotel = [];
        let points = this.hotels
            .filter(h => h.locationInfo && h.locationInfo.latitude)
            .map(h => {
                const lat = parseFloat(h.locationInfo?.latitude);
                const lng = parseFloat(h.locationInfo?.longitude);
                if (!isFinite(lat) || !isFinite(lng)) return null;
                if (h.taxes) {
                    h.taxes.feesAmountTotal = this.config.feesIncludes ? h.taxes?.breakdown?.breakDowns
                    .filter(fee => this.config.breakDownExcludedList.includes(fee.title))
                    .reduce((acc, fee) => acc + fee.amount, 0) : 0;

                    h.taxes.feesAmountTotalForNight = this.config.feesIncludes ? h.taxes.feesAmountTotal / h.nights : 0;
                }
                let campaignObj = null;
                if (window.__pt && Array.isArray(window.__pt.campaings)) {
                    for (const campaign of window.__pt.campaings) {
                        if (campaign && campaign.badgeType && Array.isArray(campaign.targetProductIds) && campaign.targetProductIds.includes(Number(h.productId))) {
                            campaignObj = Object.assign({}, campaign, { badgeType: campaign.badgeType.trim().toLowerCase() });
                            break;
                        }
                    }
                }
                h.campaignObj = campaignObj;
                this.itemsHotel.push({
                    id: h.productId,
                    productId: h.productId,
                    url: h.url,
                    name: h.name,
                    price: h.price,
                    latitude: lat,
                    longitude: lng,
                    cloudUri: h.mainPhoto?.cloudUri && this.resolution?.list?.width && this.resolution?.list?.height
                        ? `${h.mainPhoto.cloudUri}?tx=w_${this.resolution.list.width},h_${this.resolution.list.height},g_auto,c_fill`
                        : `/assets/img/placeholder_img_${this.config && this.config.siteName === "tiquetesbaratos" ? "co" : "us"}.png`,
                    stars: Math.round(h.stars),
                    surveyAverage: h.surveyAverage,
                    highlights: h.highlights,
                    taxes: h.taxes,
                    services: h.services,
                    productType: h.productType,
                    city: h.locationInfo?.city || h.city,
                    locationInfo: h.locationInfo,
                    isSponsored: h.isSponsored,
                    phone: h.phone,
                    isNews: h.isNews,
                    campaignObj: h.campaignObj
                });
                return { latitude: lat, longitude: lng };
            })
            .filter(Boolean);
        if (!points.length) {
            this.clearMarkers();
            this.safeApply(() => {
                this.vm.no_result_map = 0;
                this.vm.loading = false;
                this.vm.loading_refresh_map = false;
            });
            return;
        }
    
        const bounds = new google.maps.LatLngBounds();
        points.forEach(p => bounds.extend({ lat: p.latitude, lng: p.longitude }));
        if (!this.mapInitialized) {
            await this.initializeGoogleMap(bounds.getCenter());
            this.mapInitialized = true;
        }
        
        if (this.isNearbyFlow) {
            this.userCoords = this.hotelBookerStore.nearbyLocation?.coords;
            
            if (!this.userCoords) {
                await this.getLocationUser();
                this.userCoords = this.hotelBookerStore.nearbyLocation?.coords;
            }

            if (this.userCoords) {
                bounds.extend({ lat: this.userCoords.lat, lng: this.userCoords.lng });
                if (!this.mapInitialized) {
                    await this.initializeGoogleMap(this.userCoords);
                    this.mapInitialized = true;
                }
                this.createMyLocationMarker(this.userCoords.lat, this.userCoords.lng);
            }
        }

        if (!this.mapInitialized) {
            await this.initializeGoogleMap(bounds.getCenter());
            this.mapInitialized = true;
        }

        this._lastBounds = bounds;
        
        if (this.isNearbyFlow && this.userCoords) {
            this.map.setCenter({ lat: this.userCoords.lat, lng: this.userCoords.lng });
            this.map.setZoom(13);
        } else {
            this.map.fitBounds(bounds, 80);
            const listener = google.maps.event.addListener(this.map, "idle", () => {
                if (this.map.getZoom() > 16) this.map.setZoom(15);
                google.maps.event.removeListener(listener);
            });
        }
        await this.settingCluster(this.itemsHotel);
        this.safeApply(() => {
            this.vm.no_result_map = this.itemsHotel.length;
            
            setTimeout(() => {
                this.safeApply(() => {
                    this.vm.renderMapList = true;
                    this.vm.loading = false;
                    this.vm.loading_refresh_map = false;
                });
                this.vm.initializeSliders(this.vm.hotelFilters.filterCustoms.prices);
            }, 600);
        });
    }
    async initializeMap(latMid, lonMid) {
        const center = { lat: latMid, lng: lonMid };
        await this.initializeGoogleMap(center);
        await this.settingCluster(this.itemsHotel);
    }

    createMyLocationMarker(lat, lng) {
        if (this.myLocationMarker) this.myLocationMarker.map = null;
        const latLng = { lat, lng };
        const html = `
            <div class="user-location-marker">
                <div class="pulse"></div>
            </div>`;
        
        const { AdvancedMarkerElement } = this.lib.marker;
        this.myLocationMarker = new AdvancedMarkerElement({
            map: this.map,
            position: latLng,
            content: (() => {
                const div = document.createElement('div');
                div.innerHTML = html.trim();
                return div.firstChild;
            })()
        });
    }
    async initializeGoogleMap(center, zoom = 12) {
        this.lib.maps = await google.maps.importLibrary("maps");
        this.lib.marker = await google.maps.importLibrary("marker");
        const { Map } = this.lib.maps;
        this.map = new Map(document.getElementById('map'), {
            zoom,
            center: center,
            mapId: "hotel_list_map",
            renderingType: 'VECTOR',
            tilt: 60,
            heading: 0,
            disableDefaultUI: true,
            zoomControl: false,
            rotateControl: true,
            tiltControl: true,
            gestureHandling: "greedy",
            clickableIcons: false,
            styles: [
                { featureType: "poi.attraction", elementType: "all", stylers: [{ visibility: "on" }] },
                { featureType: "poi.business", elementType: "all", stylers: [{ visibility: "on" }] },
                { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
                { featureType: "poi.place_of_worship", elementType: "all", stylers: [{ visibility: "on" }] },
                { featureType: "poi", elementType: "all", stylers: [{ visibility: "on" }] },
                { featureType: "poi.lodging", elementType: "all", stylers: [{ visibility: "off" }] },
                { featureType: "transit", stylers: [{ visibility: "off" }] },
                { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] }
            ]
        });
        this.map.addListener("idle", () => {
            const c = this.map.getCenter();
            const currentFiltersKey = this.getFiltersKey();
            if (this._lastFiltersKey !== currentFiltersKey) {
                this._lastFiltersKey = currentFiltersKey;
                this.paramsFilter.lat = c.lat();
                this.paramsFilter.lng = c.lng();
            }            
        });
        this.map.addListener("click", () => {
            if (Date.now() - (this.lastSelectionTime || 0) < 500) {
                return;
            }
            this.safeApply(() => {
                this.vm.onCloseMapCardDetail(true);
            });
        });
    }
    zoomIn() {
        if (this.map) this.map.setZoom(this.map.getZoom() + 1);
    }
    zoomOut() {
        if (this.map) this.map.setZoom(this.map.getZoom() - 1);
    }
    toggleExpand() {
        this.safeApply(() => {
            this.vm.isMapExpanded = !this.vm.isMapExpanded;
            setTimeout(() => {
                google.maps.event.trigger(this.map, 'resize');
            }, 300);
        });
    }
    clearMarkers() {
        this.markers.forEach(m => {
            m.map = null;
        });
        this.markers = [];
        this.markerMap.clear();
        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
            this.markerCluster = null;
        }
    }
    clearBubble() {
        $(".speech-bubble.speech-bubble-active").removeClass('speech-bubble-active');
    }
    getFiltersKey() {
        const selected = this.vm.filtersSelectedArrayString.join(',');
        const custom = this.vm.filterCustomList.map(f => f.uri).join(',');
        return `${selected}|${custom}`;
    }
    async settingCluster(filteredHotels) {
        if (!this.map || !this.lib.marker) return;
        const { AdvancedMarkerElement } = this.lib.marker;
        const onMarkerClick = (h) => {
            this.lastSelectionTime = Date.now();
            this.clearBubble();
            this.safeApply(() => {
                const badges = {};
                let campaignObj = null;
                if (window.__pt && Array.isArray(window.__pt.campaings)) {
                    for (const campaign of window.__pt.campaings) {
                        if (campaign && campaign.badgeType && Array.isArray(campaign.targetProductIds) && campaign.targetProductIds.includes(Number(h.id))) {
                            campaignObj = Object.assign({}, campaign, { badgeType: campaign.badgeType.trim().toLowerCase() });
                            break;
                        }
                    }
                }
                if (this.config.hotelPromotionalBadges) {
                    for (const badgeName in this.config.hotelPromotionalBadges) {
                        if (Array.isArray(this.config.hotelPromotionalBadges[badgeName]) && this.config.hotelPromotionalBadges[badgeName].includes(Number(h.id))) {
                            const propertyName = "show" + badgeName.charAt(0).toUpperCase() + badgeName.slice(1);
                            badges[propertyName] = true;
                        }
                    }
                }
                this.vm.detailCardMap = {
                    id: h.id,
                    productId: h.id,
                    name: h.name,
                    stars: Math.round(h.stars),
                    cloudUri: h.cloudUri,
                    surveyAverage: h.surveyAverage,
                    price: h.price,
                    discount: h.discount,
                    beforePromo: h.beforePromo,
                    taxPerRoomPerNight: h.taxPerRoomPerNight,
                    highlights: h.highlights,
                    url: h.url,
                    taxes: h.taxes,
                    isFavorite: this.vm.isFavoriteHotel(h.id),
                    services: h.services,
                    productType: h.productType,
                    locationInfo: h.locationInfo,
                    isNews: h.isNews,
                    phone: h.phone,
                    isSponsored: h.isSponsored,
                    campaignObj: campaignObj,
                    ...badges
                };
                this.vm.detailCardMap.show = true;
                this.vm.mapCardOpenedAt = Date.now();
            });
            setTimeout(() => {
                const el = document.getElementById(`hotel_bubble_${h.id}`);
                if (el) el.classList.add('speech-bubble-active');
                
                const fallbackCode = this.config.siteName === "tiquetesbaratos" ? "co" : "us";
                const fallbackUrl = `/assets/img/placeholder_img_${fallbackCode}.png`;
                
                const imgUrl = h.cloudUri ? `${h.cloudUri}?tx=g_auto,c_fill,w_400,h_250` : fallbackUrl;
                
                let img = new Image();
                img.onload = () => $('#image-map-card').css('background-image', `url('${imgUrl}')`);
                img.onerror = () => $('#image-map-card').css('background-image', `url('${fallbackUrl}')`);
                img.src = imgUrl;
            }, 100);

             if (!this.fn.mobileAndTabletCheck()) {
                setTimeout(() => {
                    const listItem = document.getElementById(`hotel-item-${h.id}`);
                    if (listItem) {
                        listItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 300);
            }
        };
        const coordMap = new Map();
        const markerPromises = filteredHotels.map(async h => {
            let lat = parseFloat(h.latitude);
            let lng = parseFloat(h.longitude);
            const key = `${lat.toFixed(6)},${lng.toFixed(6)}`;
            const count = coordMap.get(key) || 0;
            coordMap.set(key, count + 1);
            if (count > 0) {
                lat += (Math.random() - 0.5) * 0.00015;
                lng += (Math.random() - 0.5) * 0.00015;
            }
            const html = `
                <div id="hotel_bubble_${h.id}" class="speech-bubble ${h.price <= 0 ? 'no-price' : ''}">
                    ${this.vm.isFavoriteHotel(h.id) ? '<i class="icons-heart"></i>' : ''}
                    <span>${h.price > 0 ? this.vm.renderCurrencyDisplay(h.price, h.id) : '<i class="icons-hotel-regular-full"></i>'}</span>
                </div>`;
            if (this.markerMap.has(h.id)) {
                const marker = this.markerMap.get(h.id);
                marker.position = new google.maps.LatLng(lat, lng);
                marker.collisionBehavior = google.maps.CollisionBehavior.REQUIRED;
                marker.update(html);
                return marker;
            }
            const marker = await createAdvancedMarker({
                latlng: new google.maps.LatLng(lat, lng),
                map: null,
                id: h.id,
                html: html,
                title: h.name,
                zIndex: 10,
                collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
                AdvancedMarkerElement
                  });
            marker.addListener('click', (event) => {
                if (event && event.domEvent) {
                    event.domEvent.preventDefault();
                    event.domEvent.stopPropagation();
                } else if (event && event.stopPropagation) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onMarkerClick(h);
            });
            this.markerMap.set(h.id, marker);
            return marker;
        });
        this.markers = await Promise.all(markerPromises);
        const profileId = this.paramsFilter.profileId || this.vm.paramsFilter?.profileId;
        if (profileId) {
            const selId = String(profileId);
            const hotel = filteredHotels.find(h => String(h.id) === selId);
            const selectedMarker = this.markers.find(m => String(m.id) === selId);
            if (selectedMarker && hotel) {
                this.map.setCenter(selectedMarker.position);
                this.map.setZoom(16);
                setTimeout(() => onMarkerClick(hotel), 800);
            }
        }
        const onClusterClick = (event, cluster, map) => {
            const markers = cluster.markers;
            if (markers && markers.length > 0) {
                const bounds = new google.maps.LatLngBounds();
                markers.forEach(m => bounds.extend(m.position));
                
                const currentZoom = map.getZoom();
                map.fitBounds(bounds, { top: 150, right: 150, bottom: 150, left: 150 });
                
                // If zoom doesn't change (markers same spot), force it!
                setTimeout(() => {
                    if (map.getZoom() <= currentZoom) {
                        map.setZoom(currentZoom + 2);
                    }
                }, 100);
                return false;
            }
        };
        if (!this.markerCluster) {
            this.markerCluster = new MarkerClusterer({
                map: this.map,
                markers: this.markers,
                onClusterClick,
                renderer: {
                    render: ({ count, position }) => {
                        const div = document.createElement('div');
                        const bg = getComputedStyle(document.documentElement).getPropertyValue('--marker-cluster-bg').trim();
                        div.style.cssText = `
                            background: ${bg};
                            color: white;
                            border: 2px solid rgba(255,255,255,0.95);
                            border-radius: 50px;
                            padding: 0 12px;
                            min-width: 40px;
                            height: 32px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 800;
                            font-size: 15px;
                            box-shadow: 0 6px 16px rgba(0,0,0,0.3);
                            letter-spacing: -0.2px;
                            white-space: nowrap;
                            font-family: 'Outfit', sans-serif;
                            cursor: pointer;
                            transition: transform 0.2s ease;
                        `;
                        div.innerHTML = `<span>+${count}</span>`;
                        const marker = new AdvancedMarkerElement({
                            position,
                            content: div,
                            zIndex: 2000
                        });
                        return marker;
                    }
                }
            });
        } else {
            this.markerCluster.clearMarkers();
            this.markerCluster.addMarkers(this.markers);
        }
    }

    updateMarkerFavorite(hotelId) {
        const marker = this.markerMap.get(hotelId);
        if (marker) {
            const hotel = this.itemsHotel.find(h => h.id === hotelId);
            if (hotel) {
                const html = `
                    <div id="hotel_bubble_${hotel.id}" class="speech-bubble ${hotel.price <= 0 ? 'no-price' : ''}">
                        ${this.vm.isFavoriteHotel(hotel.id) ? '<i class="icons-heart"></i>' : ''}
                        <span>${hotel.price > 0 ? this.vm.renderCurrencyDisplay(hotel.price, hotel.id) : '<i class="icons-hotel-regular-full"></i>'}</span>
                    </div>`;
                marker.update(html);
            }
        }
    }
}
